import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const ImpersonateExchangeRequestDtoSchema = z.object({
  token: z.string(),
});

const ImpersonateExchangeResponseDtoSchema = z.object({
  accessToken: z.string(),
  user: UserDtoSchema,
});

export type ImpersonateExchangeRequestDto = z.infer<
  typeof ImpersonateExchangeRequestDtoSchema
>;
export type ImpersonateExchangeResponseDto = z.infer<
  typeof ImpersonateExchangeResponseDtoSchema
>;

export const impersonateExchange = (
  dto: ImpersonateExchangeRequestDto,
  config?: AxiosRequestConfig<ImpersonateExchangeRequestDto>
) => {
  const data = ImpersonateExchangeRequestDtoSchema.parse(dto);
  return api
    .post('/auth/impersonate/exchange', data, config)
    .then(responseContract(ImpersonateExchangeResponseDtoSchema));
};
